
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showCancellationPage: false,
};

const cancelPageSlice = createSlice({
  name: "cancelPage",
  initialState,
  reducers: {
    showCancellationPage: (state) => {
      state.showCancellationPage = true;
    },
    hideCancellationPage: (state) => {
      state.showCancellationPage = false;
    },
  },
});

export const { showCancellationPage, hideCancellationPage } = cancelPageSlice.actions;
export default cancelPageSlice.reducer;
